import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from '@/mixins/infoList';
import { merchantList, editMerchantInfo, transferToWithdraw, changeMerchantStatus, changeMerchantWeightStatus } from '@/api/merchant';
import { getChannelIDTypeList, getChannelList } from '@/api/channel';
import GoogleCodeDialog from '@/components/GoogleCodeDialog.vue';
export default {
  name: 'Merchant',
  components: {
    GoogleCodeDialog: GoogleCodeDialog
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: merchantList,
      Merchantname: '',
      editDialogVisible: false,
      transferDialogVisible: false,
      formLabelWidth: '110px',
      // 编辑对话框的数据
      MerchantInfoFrom: {
        payInKey: '',
        payOutKey: '',
        payInChannel: null,
        payOutChannel: null,
        payInRate: '',
        payOutRate: '',
        ips: '',
        merchantId: null,
        name: '',
        limit: null,
        payInAmount: null,
        payInMaxAmount: null,
        payInMinAmount: null,
        payOutAmount: null,
        payOutMaxAmount: null,
        payOutMinAmount: null
      },
      Amount: '',
      // 修改对话框的数据
      MerchanTransferFrom: {
        MerchantId: null,
        Amount: null,
        Sign: null
      },
      addDialogVisible: false,
      editInChannel: '',
      editOutChannel: '',
      channelList: {},
      payInChannel: '',
      payOutChannel: '',
      displayInput: true,
      editInChannelIdList: [],
      editOutChannelIdList: [],
      payInAmount: null,
      payOutAmount: null,
      CFbalance: {},
      CFbalanceName: [],
      continuousCilck: true,
      // Google验证码弹窗相关
      googleCodeDialogVisible: false,
      googleCode: '',
      currentAction: null,
      currentActionParams: null
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.pageSize = 100;
            _this.searchInfo.PayOutChannel = -1;
            _this.searchInfo.PayInChannel = -1;
            _this.getChannel();
            _context.next = 1;
            return _this.getTableData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getChannel: function getChannel() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getChannelList();
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.channelList = res.data;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    editMerchant: function editMerchant(list) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var key, res, res1;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              for (key in _this3.MerchantInfoFrom) {
                if (key !== 'payInChannel' && key !== 'payOutChannel' && key !== 'payInAmount' && key !== 'amount' && key !== 'payInMaxAmount' && key !== 'payInMinAmount' && key !== 'payOutAmount' && key !== 'payOutMaxAmount' && key !== 'payOutMinAmount' && key !== 'limit') {
                  _this3.MerchantInfoFrom[key] = list[key];
                } else if (key === 'payInChannel') {
                  _this3.MerchantInfoFrom.payInChannel = _this3.searchOption(_this3.channelList, list[key]);
                  _this3.editInChannel = list[key];
                } else if (key === 'payOutChannel') {
                  _this3.MerchantInfoFrom.payOutChannel = _this3.searchOption(_this3.channelList, list[key]);
                  _this3.editOutChannel = list[key];
                } else if (key === 'payInAmount' || key === 'amount' || key === 'payInMaxAmount' || key === 'payInMinAmount' || key === 'payOutAmount' || key === 'payOutMaxAmount' || key === 'payOutMinAmount' || key === 'limit') {
                  _this3.MerchantInfoFrom[key] = list[key] / 100;
                }
              }
              _this3.MerchantInfoFrom.PayOutChannel = _this3.searchOption(_this3.channelList, list['payOutChannel']);
              _context3.next = 1;
              return getChannelIDTypeList({
                ChannelId: _this3.MerchantInfoFrom.PayOutChannel,
                Type: 1
              });
            case 1:
              res = _context3.sent;
              if (!(res.code === 0)) {
                _context3.next = 4;
                break;
              }
              res.data.forEach(function (item) {
                _this3.editOutChannelIdList.push(item.ID);
              });
              _this3.MerchantInfoFrom.PayInChannel = _this3.searchOption(_this3.channelList, list['payInChannel']);
              _context3.next = 2;
              return getChannelIDTypeList({
                ChannelId: _this3.MerchantInfoFrom.PayInChannel,
                Type: 0
              });
            case 2:
              res1 = _context3.sent;
              if (!(res1.code === 0)) {
                _context3.next = 4;
                break;
              }
              if (!(res1.data === null)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              res1.data.forEach(function (item1) {
                _this3.editInChannelIdList.push(item1.ID);
              });
            case 4:
              _this3.MerchantInfoFrom.MerchantId = list.id;
              _this3.editDialogVisible = true;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    transferMerchant: function transferMerchant(list) {
      this.MerchanTransferFrom.MerchantId = list.id;
      this.payInAmount = list.payInAmount / 100;
      this.payOutAmount = list.payOutAmount / 100;
      this.transferDialogVisible = true;
    },
    addMerchantMount: function addMerchantMount(list) {
      this.Merchantname = list.name;
      this.MerchanTransferFrom.MerchantId = list.id;
      this.addDialogVisible = true;
    },
    confirmTransfer: function confirmTransfer(flag) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (flag) {
                _this4.MerchanTransferFrom.Sign = 1;
                _this4.MerchanTransferFrom.Amount = -1;
              } else {
                _this4.MerchanTransferFrom.Sign = 2;
                _this4.MerchanTransferFrom.Amount = parseInt(parseFloat(_this4.Amount) * 100);
              }
              _this4.openGoogleCodeDialog('transfer');
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    doTransfer: function doTransfer() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.MerchanTransferFrom.google_code = _this5.googleCode;
              if (!_this5.continuousCilck) {
                _context5.next = 3;
                break;
              }
              _this5.continuousCilck = false;
              _context5.next = 1;
              return transferToWithdraw(_this5.MerchanTransferFrom);
            case 1:
              res = _context5.sent;
              if (!(res.code === 0)) {
                _context5.next = 2;
                break;
              }
              _this5.$message.success(res.msg);
              _this5.transferDialogVisible = false;
              _this5.closeGoogleCodeDialog();
              _context5.next = 2;
              return _this5.getTableData();
            case 2:
              _this5.continuousCilck = true;
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    addconfirmTransfer: function addconfirmTransfer() {
      this.MerchanTransferFrom.Sign = 3;
      this.MerchanTransferFrom.Amount = parseInt(parseFloat(this.Amount) * 100);
      this.openGoogleCodeDialog('addAmount');
    },
    doAddAmount: function doAddAmount() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this6.MerchanTransferFrom.google_code = _this6.googleCode;
              _context6.next = 1;
              return transferToWithdraw(_this6.MerchanTransferFrom);
            case 1:
              res = _context6.sent;
              if (!(res.code === 0)) {
                _context6.next = 2;
                break;
              }
              _this6.$message.success(res.msg);
              _this6.addDialogVisible = false;
              _this6.closeGoogleCodeDialog();
              _context6.next = 2;
              return _this6.getTableData();
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    closeTransferDialog: function closeTransferDialog() {
      this.MerchanTransferFrom.Amount = null;
      this.displayInput = true;
      this.Amount = '';
    },
    closeEditDialog: function closeEditDialog() {
      this.$refs.merchantInfoFromref.resetFields();
      this.editInChannelIdList = [];
      this.editOutChannelIdList = [];
      console.log(this.MerchantInfoFrom);
    },
    editInChannelSelect: function editInChannelSelect() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this7.MerchantInfoFrom.PayInChannel = _this7.searchOption(_this7.channelList, _this7.editInChannel);
              _this7.editInChannelIdList = [];
              _context7.next = 1;
              return getChannelIDTypeList({
                ChannelId: _this7.MerchantInfoFrom.PayInChannel,
                Type: 0
              });
            case 1:
              res = _context7.sent;
              if (!(res.code === 0)) {
                _context7.next = 3;
                break;
              }
              if (!(res.data === null)) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              res.data.forEach(function (item) {
                _this7.editInChannelIdList.push(item.ID);
              });
              _this7.MerchantInfoFrom.payInKey = _this7.editInChannelIdList[0];
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    editOutChannelSelect: function editOutChannelSelect() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.MerchantInfoFrom.PayOutChannel = _this8.searchOption(_this8.channelList, _this8.editOutChannel);
              _this8.editOutChannelIdList = [];
              _context8.next = 1;
              return getChannelIDTypeList({
                ChannelId: _this8.MerchantInfoFrom.PayOutChannel,
                Type: 1
              });
            case 1:
              res = _context8.sent;
              if (!(res.code === 0)) {
                _context8.next = 3;
                break;
              }
              if (!(res.data === null)) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              res.data.forEach(function (item) {
                _this8.editOutChannelIdList.push(item.ID);
              });
              _this8.MerchantInfoFrom.payOutKey = _this8.editOutChannelIdList[0];
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    editweightStatus: function editweightStatus(isOpen, id, type) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var weightStatus, res;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              weightStatus = isOpen === '权重打开' ? 1 : 0;
              _context9.next = 1;
              return changeMerchantWeightStatus({
                MerchantId: id,
                Status: weightStatus,
                type: type
              });
            case 1:
              res = _context9.sent;
              if (!(res.code === 0)) {
                _context9.next = 2;
                break;
              }
              _this9.$message.success(res.msg);
              _context9.next = 2;
              return _this9.getTableData();
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    // 打开Google验证码弹窗
    openGoogleCodeDialog: function openGoogleCodeDialog(action) {
      this.currentAction = action;
      this.googleCodeDialogVisible = true;
    },
    closeGoogleCodeDialog: function closeGoogleCodeDialog() {
      this.googleCodeDialogVisible = false;
      this.googleCode = '';
      this.currentAction = null;
    },
    confirmGoogleCode: function confirmGoogleCode(code) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _this0.googleCode = code;
              if (!(_this0.currentAction === 'editMerchant')) {
                _context0.next = 2;
                break;
              }
              _context0.next = 1;
              return _this0.doEditMerchant();
            case 1:
              _context0.next = 5;
              break;
            case 2:
              if (!(_this0.currentAction === 'transfer')) {
                _context0.next = 4;
                break;
              }
              _context0.next = 3;
              return _this0.doTransfer();
            case 3:
              _context0.next = 5;
              break;
            case 4:
              if (!(_this0.currentAction === 'addAmount')) {
                _context0.next = 5;
                break;
              }
              _context0.next = 5;
              return _this0.doAddAmount();
            case 5:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    doEditMerchant: function doEditMerchant() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var res;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _this1.MerchantInfoFrom.google_code = _this1.googleCode;
              _context1.next = 1;
              return editMerchantInfo(_this1.MerchantInfoFrom);
            case 1:
              res = _context1.sent;
              if (!(res.code === 0)) {
                _context1.next = 2;
                break;
              }
              _this1.$message.success(res.msg);
              _this1.editDialogVisible = false;
              _this1.closeGoogleCodeDialog();
              _context1.next = 2;
              return _this1.getTableData();
            case 2:
            case "end":
              return _context1.stop();
          }
        }, _callee1);
      }))();
    },
    confirmMerchant: function confirmMerchant() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this10.openGoogleCodeDialog('editMerchant');
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    deleteUser: function deleteUser(id) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this11.$confirm("\u4F60\u5C06\u8981\u5220\u9664".concat(id, "\u5546\u6237, \u662F\u5426\u7EE7\u7EED?"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var res;
                return regeneratorRuntime.wrap(function (_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      _context11.next = 1;
                      return changeMerchantStatus({
                        MerchantId: id,
                        Status: 0
                      });
                    case 1:
                      res = _context11.sent;
                      if (!(res.code === 0)) {
                        _context11.next = 2;
                        break;
                      }
                      _this11.$message.success('删除成功');
                      _context11.next = 2;
                      return _this11.getTableData();
                    case 2:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11);
              }))).catch(function () {
                _this11.$message({
                  type: 'info',
                  message: "\u5DF2\u53D6\u6D88\u5220\u9664"
                });
              });
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    } // async getbalance(){
    //   const res = await checkCashFreeAmount()
    //   if (res.code === 0) {
    //     this.CFbalance = res.data
    //     this.CFbalanceName =Object.keys(res.data)
    //     console.log(this.CFbalanceName)
    //     console.log(this.CFbalance)
    //   }
    // }
  }
};